import React, { FC } from 'react';

import { MappedOrderItemType, MappedOrderItemUserType } from '../../../services/apis/order/types';
import { Friends } from './Friends';
import { ManualFriends } from './ManualFriends';
import { PlayersInFlight } from './PlayersInFlight';
import { FriendType, MainUserError } from './types';

/**
 * Props for the Players component
 */
interface PlayersProps {
  players: MappedOrderItemUserType[];
  removePlayer: (player: MappedOrderItemUserType) => void;
  userFriends: FriendType[];
  onFriendAddClick: (data: any) => void;
  isGolfhaftetRequest: boolean;
  isThirdParty: boolean;
  isGitBooking: boolean;
  item?: MappedOrderItemType;
  disabled: boolean;
  isValidatingMainUser: string | number | undefined | null;
  mainUserError: MainUserError | null;
}

/**
 * Players component that displays the list of players in a flight
 * and provides options to add friends or manual players
 */
export const Players: FC<PlayersProps> = ({
  players,
  removePlayer,
  userFriends,
  onFriendAddClick,
  isGolfhaftetRequest,
  isThirdParty,
  isGitBooking,
  item,
  disabled,
  isValidatingMainUser,
  mainUserError,
}) => {
  const seatsInFlight = item?.amount;
  const playersInFlight = players?.length;
  const flightFull = playersInFlight === item?.amount;

  return (
    <div>
      <PlayersInFlight
        item={item}
        players={players}
        playersInFlight={playersInFlight}
        seatsInFlight={seatsInFlight}
        flightFull={flightFull}
        removePlayer={removePlayer}
        isGolfhaftetRequest={isGolfhaftetRequest}
        isGitBooking={isGitBooking}
        disabled={disabled}
        isThirdParty={isThirdParty}
        isValidatingMainUser={isValidatingMainUser}
        mainUserError={mainUserError}
      />

      {!flightFull && userFriends?.length > 0 && (
        <Friends
          item={item}
          players={players}
          friends={userFriends}
          flightFull={flightFull}
          onFriendAddClick={onFriendAddClick}
          isGolfhaftetRequest={isGolfhaftetRequest}
        />
      )}

      {!flightFull && (
        <ManualFriends
          item={item}
          players={players}
          isGolfhaftetRequest={isGolfhaftetRequest}
          isThirdParty={isThirdParty}
          onFriendAddClick={onFriendAddClick}
          isGitBooking={isGitBooking}
        />
      )}
    </div>
  );
};
